import React from 'react';

export interface EmbeddedQuizEditorContextType {
  /** When set, indicates the quiz editor is embedded (e.g. inside a modal). */
  isEmbedded: true;
  /** Close the embedding container (e.g. the modal). */
  onClose: () => void;
}

const EmbeddedQuizEditorContext = React.createContext<EmbeddedQuizEditorContextType | null>(null);

export const EmbeddedQuizEditorProvider = EmbeddedQuizEditorContext.Provider;

export const useEmbeddedQuizEditor = () => React.useContext(EmbeddedQuizEditorContext);
